import React from 'react';

import { runningInRNWebView, postMessageRN, WebToRNAction } from '@eika-infrastruktur/mobilbank-lib';
import { FileButton } from '@eika/button';

import { useTranslation } from '../../../translations';

import './FundingCertificatesAttachments.scss';

interface TaskDocumentsInterface {
    fundingCertificateText: string;
    downloadFundingCertificateUrl: string;
}
const FundingCertificatesAttachments = ({
    fundingCertificateText,
    downloadFundingCertificateUrl,
}: TaskDocumentsInterface) => {
    const { task } = useTranslation();

    return (
        <div className="funding-certificates-attachments">
            <div className="semibold">{task.attachmentsTitle}</div>
            <div className="funding-certificates-attachments__download-button">
                <FileButton
                    onClick={(e) => {
                        if (runningInRNWebView) {
                            e.preventDefault();
                            postMessageRN({
                                action: WebToRNAction.OPEN_PDF,
                                payload: {
                                    url: downloadFundingCertificateUrl,
                                    title: fundingCertificateText,
                                },
                            });
                        }
                    }}
                    href={downloadFundingCertificateUrl}
                    text={fundingCertificateText}
                />
            </div>
        </div>
    );
};

export default FundingCertificatesAttachments;
